import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function LinkedIn() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("LinkedIn")}</legend>
      <input
        onChange={onChange}
        value={searchObject.linkedIn || ""}
        name="linkedIn"
        className="form-control"
      />
    </fieldset>
  );
}
